import { v4 as uuidv4 } from 'uuid';
import { FalsificatGridView } from './FalsificatGridView';
import FalsificatGridPluginSettings from './FalsificatGridPluginSettings';

export const FalsificatTab = (): ITab => {
    return {
        id: uuidv4(),
        title: 'Фальсификаты',
        view: {
            content: FalsificatGridPluginSettings
                ? <FalsificatGridView gridId={uuidv4()} plugin={FalsificatGridPluginSettings} isDetail={true} />
                : <p> Справочник не настроен </p>
        }
    }
}

export default FalsificatTab